export default "__VITE_ASSET__dee612cc__"